@if (entry?.base?.display) {
  <div>
    <div class='member-lookup-search-msg'>
      <em>You are searching for members in <strong>{{ currentRegion }}</strong></em>
      &nbsp;&nbsp;
      <a href='' (click)='changeRegion(false, $event)'>Change Region</a>
    </div>
    <app-member-lookup
      [isPlanChange]="true"
      [zipSegment]="zipSegment"
      (memberLookupResponse)="onMemberLookupResponse($event)"
      (crosswalkResponse)="onCrosswalkResponse($event)">
    </app-member-lookup>
  </div>
}